import React from "react";
import { Edit2 } from "react-feather";
import { InlineDetailRow } from "../../molecules";
import { Card, EditButton, RowsContainer } from "./ConnectionCredentialsCard.styles";
import type { ConnectionCredentialsCardProps } from "./ConnectionCredentialsCard.types";

/**
 * Integration configuration card — top-right on Connection Detail (UI-4).
 * One row per entry in API `integration_configs` (`ConnectionDetail.integrationRows`).
 * Rows are distributed evenly to fill available space.
 */
export const ConnectionCredentialsCard: React.FC<
  ConnectionCredentialsCardProps
> = ({ rows, onEdit, className }) => (
  <Card className={className} aria-label="Connection configuration">
    {onEdit ? (
      <EditButton type="button" onClick={onEdit} aria-label="Edit credentials">
        <Edit2 size={16} />
      </EditButton>
    ) : null}
    <RowsContainer>
      {rows.map((row) => (
        <InlineDetailRow
          key={row.fieldKey}
          label={row.label}
          value={row.value}
        />
      ))}
    </RowsContainer>
  </Card>
);

export default ConnectionCredentialsCard;
